import { render } from "./PublicQuestionsSidebarComponent.vue?vue&type=template&id=62bb3e1c&scoped=true"
import script from "./PublicQuestionsSidebarComponent.vue?vue&type=script&lang=js"
export * from "./PublicQuestionsSidebarComponent.vue?vue&type=script&lang=js"

import "./PublicQuestionsSidebarComponent.vue?vue&type=style&index=0&id=62bb3e1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bb3e1c"]])

export default __exports__